import NetworkLogic from "../../Shared/NetworkLogic";
import data = cc.data;
import UIManager from "../../Shared/UIManager";
import Player from "../../Models/Player";
import {Global} from "../../Shared/Global";
const i18n = require('LanguageData');

const {ccclass, property} = cc._decorator;

@ccclass
export default class CaiFuBang extends cc.Component {

    @property([cc.SpriteFrame])
    bgArr: cc.SpriteFrame[] = [];
    @property(cc.SpriteFrame)
    spNo1: cc.SpriteFrame = null;
    @property(cc.SpriteFrame)
    spNo2: cc.SpriteFrame = null;
    @property(cc.SpriteFrame)
    spNo3: cc.SpriteFrame = null;
    @property(cc.Node)
    item: cc.Node = null;
    @property(cc.Node)
    content: cc.Node = null;//分享奖励


    start () {
        UIManager.showLoadingUI();
        NetworkLogic.agentGetRanking({},function (data) {
            UIManager.hideLoadingUI();
            console.log("===财富榜数据 data：",data);
            this.content.destroyAllChildren()
            for (let i = 0;i < data.length;i++){
                let child = cc.instantiate(this.item);
                if (i === 0){
                    child.getChildByName("spPaiMing").getComponent(cc.Sprite).spriteFrame = this.spNo1;
                }else if (i === 1){
                    child.getChildByName("spPaiMing").getComponent(cc.Sprite).spriteFrame = this.spNo2;
                }else if (i === 2){
                    child.getChildByName("spPaiMing").getComponent(cc.Sprite).spriteFrame = this.spNo3;
                }else{
                    child.getChildByName("spPaiMing").active = false;
                }
                child.getChildByName("bg").getComponent(cc.Sprite).spriteFrame = this.bgArr[i%2];

                child.getChildByName("labPaiMing").getComponent(cc.Label).string = i+1;
                child.getChildByName("labTotal").getComponent(cc.Label).string = data[i].userId;
                child.getChildByName("labMonthMoney").getComponent(cc.Label).string = Global.currencySymbol +  data[i].brokerageMoney;
                child.getChildByName("labShareReward").getComponent(cc.Label).string =  Global.currencySymbol +  data[i].shareBonusMoney;
                child.parent = this.content;
                child.active = true;

            }
            
        }.bind(this),function () {
            console.log("===财富榜数据错误");
        }.bind(this));

    }

    // update (dt) {}
}
